import { render } from "./ad_App.vue?vue&type=template&id=46a90c84"
import script from "./ad_App.vue?vue&type=script&lang=js"
export * from "./ad_App.vue?vue&type=script&lang=js"

import "./ad_App.vue?vue&type=style&index=0&id=46a90c84&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__